import { User } from 'types'

export const productKey = (p: { PK: string; SK: string }) => `${p.PK}|${p.SK}`

export const parseInstanceFromSK = (input?: string | null): string => {
  if (!input) return ''
  const s = String(input)

  // If someone passed "PK|SK", peel off the right bit
  const maybeSk = s.includes('|') ? s.split('|').pop()! : s

  // If it's already prefixed, strip the prefix
  if (maybeSk.startsWith('PRODUCT_')) return maybeSk.slice('PRODUCT_'.length)

  // Otherwise assume it's already a bare instance id
  return maybeSk
}
export const ensureProductSK = (p: { SK?: string; instanceId?: string } | string): string => {
  const val = typeof p === 'string' ? p : p.SK ?? p.instanceId ?? ''
  const iid = parseInstanceFromSK(val)
  if (!iid) throw new Error('ensureProductSK: missing SK/instanceId')
  return `PRODUCT_${iid}`
}
export const sameIds = (a?: User[], b?: User[]) => {
  const aa = (a ?? [])
    .map(u => u?.user_uuid)
    .filter(Boolean)
    .sort()
  const bb = (b ?? [])
    .map(u => u?.user_uuid)
    .filter(Boolean)
    .sort()
  if (aa.length !== bb.length) return false
  for (let i = 0; i < aa.length; i++) if (aa[i] !== bb[i]) return false
  return true
}
